<template>
  <div>
    <div class="title-box">
      <div class="progress">
        <a-steps class="spacing" :current="statusNum" size="small">
          <a-step>
            <template slot="title" class="title">New Booking</template>
            <span slot="description"></span>
          </a-step>
          <a-step>
            <template slot="title" class="title">Deposited</template>
            <span slot="description"><a class="link-btn" @click="handleEditDeposit">(07/08/2021)</a></span>
          </a-step>
          <a-step>
            <template slot="title" class="title">Invoiced</template>
            <span slot="description">(17215945)</span>
          </a-step>
          <a-step>
            <template slot="title" class="title">Travel Doc</template>
            <div slot="description"></div>
          </a-step>
          <a-step>
            <template slot="title" class="title">Guide's greeting</template>
            <span slot="description"></span>
          </a-step>
          <a-step>
            <template slot="title" class="title">Completed</template>
            <span slot="description"></span>
          </a-step>
        </a-steps>
      </div>
    </div>
    <a-modal
        title="Edit Deposit"
        :visible="depositVisible"
        :maskClosable="false"
        @cancel="handleDepositCancel"
      >
        <div>
          <a-form layout='vertical' :form="editForm">
            <a-form-item label='Deposit'>
              <a-date-picker
                placeholder="Please input deposit date"
                style="width: 100%"
                format="MM/DD/YYYY"
                ></a-date-picker>
            </a-form-item>
          </a-form>
        </div>
        <div slot="footer">
          <a-row type="flex" justify="end">
            <a-col :xs="9" :md="5">
              <a-popconfirm
                title="Are you sure?"
                @confirm="handleDepositOk"
                ok-text="Yes" 
                cancel-text="No"
              >
                <a-button type="primary">Confirm</a-button>
              </a-popconfirm>	
            </a-col>
          </a-row>
        </div>
      </a-modal>
  </div>
</template>

<script>
// import pick from 'lodash.pick'

export default {
  name: 'BookBasicSteps',
  components: {
  },
  props: {
  },
  data () {
    return {
      statusNum: 0,
      depositVisible: false,
      editForm: this.$form.createForm(this)
    }
  },
  mounted () {
  },
  methods: {
    handleEditDeposit () {
      this.depositVisible = true
    },
    handleDepositCancel () {
      this.depositVisible = false
    },
    handleDepositOk () {
    }
  }
}
</script>
<style lang="less" scoped>
</style>